import React from 'react';
import { Hint } from '@flexiflow-ui-kit/hint';
import { Label } from '@flexiflow-ui-kit/label';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import styled, { css } from 'styled-components';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2;
var Textarea$1 = styled.textarea(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 3px;\n  font-size: 16px;\n  line-height: 20px;\n  padding: 8px;\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 100px;\n  border: 1px solid\n    ", ";\n  color: ", ";\n  background-color: ", ";\n  resize: vertical;\n  white-space: normal;\n  overflow-y: auto;\n  outline: none;\n  ", "\n\n  :focus {\n    border-color: ", ";\n  }\n\n  :disabled {\n    border-color: ", ";\n    color: ", ";\n    cursor: not-allowed;\n    background-color: ", ";\n  }\n\n  &::-webkit-input-placeholder {\n    color: ", ";\n  }\n\n  &::-moz-placeholder {\n    color: ", ";\n  }\n\n  &:-ms-input-placeholder {\n    color: ", ";\n  }\n\n  &::-ms-input-placeholder {\n    color: ", ";\n  }\n\n  &::-ms-clear {\n    display: none;\n  }\n"])), function (p) {
  return p.hasError ? p.theme.palette.red['700'] : p.theme.palette.gray['400'];
}, function (p) {
  return p.theme.palette.black;
}, function (p) {
  return p.theme.palette.white;
}, function (p) {
  return p.maxHeight && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      max-height: ", "px;\n    "])), p.maxHeight);
}, function (p) {
  return p.hasError ? p.theme.palette.red['700'] : p.theme.palette.blue['500'];
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.gray['500'];
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.gray['500'];
}, function (p) {
  return p.theme.palette.gray['500'];
}, function (p) {
  return p.theme.palette.gray['500'];
}, function (p) {
  return p.theme.palette.gray['500'];
});

var _excluded = ["className", "disabled", "hasError", "hint", "hintKeepPlace", "label", "labelCanDisabled", "labelCount", "labelMaxCount", "hintCanDisabled", "maxHeight"];
function Textarea(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      hasError = _ref.hasError,
      hint = _ref.hint,
      hintKeepPlace = _ref.hintKeepPlace,
      label = _ref.label,
      labelCanDisabled = _ref.labelCanDisabled,
      labelCount = _ref.labelCount,
      labelMaxCount = _ref.labelMaxCount,
      hintCanDisabled = _ref.hintCanDisabled,
      maxHeight = _ref.maxHeight,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(Hint, {
    hint: hint,
    hintKeepPlace: hintKeepPlace,
    hasError: hasError,
    hintCanDisabled: hintCanDisabled,
    disabled: disabled,
    className: className
  }, /*#__PURE__*/React.createElement(Label, {
    hasError: hasError,
    label: label,
    labelCount: labelCount,
    labelMaxCount: labelMaxCount,
    disabled: disabled,
    labelCanDisabled: labelCanDisabled
  }, /*#__PURE__*/React.createElement(Textarea$1, _extends({
    hasError: hasError,
    disabled: disabled
  }, otherProps, {
    className: className,
    maxHeight: maxHeight
  })))));
}

export { Textarea };
